module.exports = __webpack_public_path__ + "client/projects/assets/job-one/job-one-cta.png";


//////////////////
// WEBPACK FOOTER
// ./client/projects/assets/job-one/job-one-cta.png
// module id = 276
// module chunks = 0